'use strict';

var _ = require('lodash');
var ROMSummaryDOWFilterFactory = function ROMSummaryDOWFilterFactory(DataFilter) {
  function ROMSummaryDOWFilter() {
    DataFilter.call(this, 'rom-summary-mode', 'dow', 0);
  }
  ROMSummaryDOWFilter.prototype = Object.create(DataFilter.prototype);
  ROMSummaryDOWFilter.prototype.filter = function (data, range) {
    var filtered = [],
      record;
    var filteredWeek;
    range = range.map(function (day) {
      return day ? day.toUpperCase() : '';
    });
    for (var index = 0, length = data.length; index < length; index++) {
      record = _.clone(data[index]);
      filteredWeek = {};
      for (var rangeIndex = 0, rangeLength = range.length; rangeIndex < rangeLength; rangeIndex++) {
        var day = range[rangeIndex];
        if (record.week[day]) {
          filteredWeek[day] = record.week[day];
        }
      }
      record.week = filteredWeek;
      filtered.push(record);
    }
    return filtered;
  };
  return ROMSummaryDOWFilter;
};
ROMSummaryDOWFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMSummaryDOWFilterFactory;